import { useState } from 'react';
import { IconButton, Popover } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import { getVisibleWidth } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';

export default function SeemoreViewKnowledgeList(props) {
    // item menu tabs
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    // end item menu tabs

    const {
        listViewShow,
        viewSelected,
        setViewSelected,
        element,
        nodeListView,
        viewStructure,
        setViewStructure,
        setTriggerSearch
    } = props;

    const onClickActiveTabChange = (e, ticketId, item) => {
        if (item.id === viewSelected.id) return;
        setViewSelected(item);
        let currentVisibility = viewStructure.visibility;
        let newView = {
            ...Utils.convertJSONDataToObject(item.structure),
            visibility: currentVisibility,
        };
        setViewStructure(newView);
        setTriggerSearch(Date.now().toString());

        setAnchorEl(null);
        let containerRect = element.getBoundingClientRect();
        let posElem = [];
        for (let i = 0; i < nodeListView.length; i++) {
            let ids = listViewShow[i].id;
            // Gets the amount of pixels currently visible within the container
            let visiblePageWidth = getVisibleWidth(nodeListView[i]);
            posElem.push({ id: ids, pos: visiblePageWidth });
        }

        let currentIndex = Utils.findIndexInArrayById(viewSelected?.id, posElem);
        let nextIndex = Utils.findIndexInArrayById(ticketId, posElem);

        let isRightPosItem = nextIndex - currentIndex > 0 ? true : false;

        if (isRightPosItem) {
            if (posElem[nextIndex].pos.left + posElem[nextIndex].pos.width > containerRect.width) {
                element.scrollLeft +=
                    posElem[nextIndex].pos.width -
                    (containerRect.width - posElem[nextIndex].pos.left);
            }
        } else {
            if (posElem[nextIndex].pos.left + posElem[nextIndex].pos.width <= containerRect.width) {
                element.scrollLeft += posElem[nextIndex].pos.left;
            }
        }
    };

    return (
        <div className="gNav-tabs">
            <IconButton
                className="itemNav"
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <img src="/assets/image/icon-navTabs.svg" alt="" />
            </IconButton>
            <Popover
                className="navTabs-drop navTabs-drop--changePd"
                id={open ? 'simple-popover' : undefined}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <ul className="list-view-seemore">
                    {listViewShow.map(item => {
                        let viewNameObj = Utils.convertJSONDataToObject(item.name);
                        let viewName = viewNameObj['jp'].text;
                        return (
                            <li
                                key={item.id}
                                onClick={e => onClickActiveTabChange(e, item.id, item)}
                                className={`${viewSelected?.id === item.id && 'item-active-li'}`}
                            >
                                <OverFlowTooltipWithTabsMui value={viewName} />
                            </li>
                        );
                    })}
                </ul>
            </Popover>
        </div>
    );
}
